import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, errMsg } from "@/lib/api";

const STATUS = {
  accesso: ["Accesso", "text-emerald-400 border-emerald-500/30"],
  password_errata: ["Password errata", "text-rose-400 border-rose-500/30"],
  otp_errato: ["OTP errato", "text-amber-400 border-amber-500/30"],
  password_reimpostata: ["Password reimpostata", "text-blue-400 border-blue-500/30"],
};

const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" });

const device = (ua) => {
  const os = /iPhone|iPad/.test(ua) ? "iOS" : /Android/.test(ua) ? "Android" : /Mac/.test(ua) ? "Mac" : /Windows/.test(ua) ? "Windows" : /Linux/.test(ua) ? "Linux" : "";
  const br = /Edg\//.test(ua) ? "Edge" : /Chrome\//.test(ua) ? "Chrome" : /Firefox\//.test(ua) ? "Firefox" : /Safari\//.test(ua) ? "Safari" : "";
  return [br, os].filter(Boolean).join(" · ") || "—";
};

export const AccessLogDialog = ({ open, onOpenChange }) => {
  const [logs, setLogs] = useState([]);
  const [onlyOk, setOnlyOk] = useState(false);

  useEffect(() => {
    if (open) api.get("/access-logs").then((r) => setLogs(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [open]);

  const rows = onlyOk ? logs.filter((l) => l.status === "accesso") : logs;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="bg-[#111827] border-slate-700 text-slate-100 sm:max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="access-log-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Registro accessi</DialogTitle></DialogHeader>
        <label className="flex items-center gap-2 text-xs text-slate-400 font-mono cursor-pointer w-fit">
          <input type="checkbox" checked={onlyOk} onChange={(e) => setOnlyOk(e.target.checked)} data-testid="access-log-only-success" className="accent-blue-600" />
          Solo accessi riusciti
        </label>
        {rows.length === 0 ? (
          <p className="text-sm text-slate-500 py-6" data-testid="access-log-empty">Nessun accesso registrato.</p>
        ) : (
          <Table data-testid="access-log-table">
            <TableHeader>
              <TableRow className="border-slate-800 hover:bg-transparent">
                <TableHead className="text-slate-400">Quando</TableHead>
                <TableHead className="text-slate-400">Utente</TableHead>
                <TableHead className="text-slate-400">Esito</TableHead>
                <TableHead className="text-slate-400 hidden sm:table-cell">Dispositivo</TableHead>
                <TableHead className="text-slate-400 hidden md:table-cell">IP</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((l) => {
                const [label, cls] = STATUS[l.status] || [l.status, "text-slate-400 border-slate-600"];
                return (
                  <TableRow key={l.id} className="border-slate-800 hover:bg-slate-800/40" data-testid={`access-log-row-${l.id}`}>
                    <TableCell className="font-mono text-xs text-slate-300 whitespace-nowrap">{fmt(l.at)}</TableCell>
                    <TableCell>
                      <p className="text-sm text-slate-100">{l.name || "—"}</p>
                      <p className="font-mono text-[11px] text-slate-500">{l.email}</p>
                    </TableCell>
                    <TableCell><span className={`font-mono text-[10px] px-2 py-0.5 rounded-full border whitespace-nowrap ${cls}`}>{label}</span></TableCell>
                    <TableCell className="text-xs text-slate-400 hidden sm:table-cell">{device(l.user_agent)}</TableCell>
                    <TableCell className="font-mono text-xs text-slate-500 hidden md:table-cell">{l.ip}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </DialogContent>
    </Dialog>
  );
};
